import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, InputBase, Divider, Grid, Card, CardContent, CardMedia, IconButton, Checkbox, FormControlLabel, Badge, Accordion, AccordionSummary, AccordionDetails, Button } from '@mui/material';
import { Search, ExpandMore, Star, Favorite, Book, LibraryBooks } from '@mui/icons-material';
import { keyframes } from '@emotion/react';
import Headers from './Headers';

const books = [
    {
      id: '1',
      title: 'The Great Gatsby',
      author: 'F. Scott Fitzgerald',
      cover: 'https://covers.openlibrary.org/b/id/7222246-L.jpg',
      category: 'Classic',
      description: 'A story of decadence and excess, Gatsby explores the American Dream in the 1920s.',
      rating: 4.5,
      year: 1925,
    },
    {
      id: '2',
      title: 'Dune',
      author: 'Frank Herbert',
      cover: 'https://covers.openlibrary.org/b/id/7292706-L.jpg',
      category: 'Science Fiction',
      description: 'A stunning blend of adventure and mysticism, environmentalism and politics.',
      rating: 4.8,
      year: 1965,
    },
    {
      id: '3',
      title: '1984',
      author: 'George Orwell',
      cover: 'https://covers.openlibrary.org/b/id/7222245-L.jpg',
      category: 'Dystopian',
      description: 'A dystopian social science fiction novel and cautionary tale.',
      rating: 4.7,
      year: 1949,
    },
    {
      id: '4',
      title: 'To Kill a Mockingbird',
      author: 'Harper Lee',
      cover: 'https://covers.openlibrary.org/b/id/7134448-L.jpg',
      category: 'Classic',
      description: 'A young girl comes of age in the racially charged South, as her father defends a black man accused of rape.',
      rating: 4.9,
      year: 1960,
    },
    {
      id: '5',
      title: 'The Catcher in the Rye',
      author: 'J.D. Salinger',
      cover: 'https://covers.openlibrary.org/b/id/10970033-L.jpg',
      category: 'Fiction',
      description: 'A novel about the confusion, alienation, and rebellion of a young man who is unable to reconcile the adult world.',
      rating: 4.2,
      year: 1951,
    },
    {
      id: '6',
      title: 'The Hobbit',
      author: 'J.R.R. Tolkien',
      cover: 'https://covers.openlibrary.org/b/id/7209239-L.jpg',
      category: 'Fantasy',
      description: 'The journey of Bilbo Baggins, a hobbit who embarks on an unexpected adventure that leads him to treasure, dragons, and a newfound sense of courage.',
      rating: 4.7,
      year: 1937,
    },
    {
      id: '7',
      title: 'The Girl with the Dragon Tattoo',
      author: 'Stieg Larsson',
      cover: 'https://covers.openlibrary.org/b/id/9870938-L.jpg',
      category: 'Mystery',
      description: 'A journalist and a hacker investigate the disappearance of a young woman from a wealthy family, uncovering shocking secrets.',
      rating: 4.3,
      year: 2005,
    },
    {
      id: '8',
      title: 'Brave New World',
      author: 'Aldous Huxley',
      cover: 'https://covers.openlibrary.org/b/id/7136066-L.jpg',
      category: 'Dystopian',
      description: 'A satirical novel exploring a society that has achieved apparent perfection at the cost of freedom, individuality, and love.',
      rating: 4.4,
      year: 1932,
    },
    {
      id: '9',
      title: 'Pride and Prejudice',
      author: 'Jane Austen',
      cover: 'https://covers.openlibrary.org/b/id/7225032-L.jpg',
      category: 'Classic',
      description: 'A romantic novel set in the 19th century, exploring themes of love, class, and societal expectations.',
      rating: 4.6,
      year: 1813,
    },
    {
      id: '10',
      title: 'The Alchemist',
      author: 'Paulo Coelho',
      cover: 'https://covers.openlibrary.org/b/id/7281372-L.jpg',
      category: 'Fiction',
      description: 'A young shepherd’s journey to find his personal legend, teaching readers about fate, love, and following dreams.',
      rating: 4.5,
      year: 1988,
    },
    {
      id: '11',
      title: 'The Lord of the Rings: The Fellowship of the Ring',
      author: 'J.R.R. Tolkien',
      cover: 'https://covers.openlibrary.org/b/id/7229384-L.jpg',
      category: 'Fantasy',
      description: 'The first part of the epic trilogy, where a young hobbit embarks on a journey to destroy a powerful ring and save Middle-earth.',
      rating: 4.8,
      year: 1954,
    },
    {
      id: '12',
      title: 'The Shining',
      author: 'Stephen King',
      cover: 'https://covers.openlibrary.org/b/id/7246401-L.jpg',
      category: 'Horror',
      description: 'A winter caretaker and his family are trapped at an isolated hotel, where supernatural forces drive him to violence.',
      rating: 4.7,
      year: 1977,
    },
    {
      id: '13',
      title: 'Murder on the Orient Express',
      author: 'Agatha Christie',
      cover: 'https://covers.openlibrary.org/b/id/10913774-L.jpg',
      category: 'Mystery',
      description: 'Hercule Poirot investigates a murder aboard a luxurious train traveling across Europe.',
      rating: 4.6,
      year: 1934,
    },
    {
      id: '14',
      title: 'The Picture of Dorian Gray',
      author: 'Oscar Wilde',
      cover: 'https://covers.openlibrary.org/b/id/6929812-L.jpg',
      category: 'Gothic Fiction',
      description: 'A young man’s portrait ages instead of him, reflecting the consequences of his life of indulgence and decadence.',
      rating: 4.4,
      year: 1890,
    },
    {
      id: '15',
      title: 'Frankenstein',
      author: 'Mary Shelley',
      cover: 'https://covers.openlibrary.org/b/id/7372751-L.jpg',
      category: 'Gothic Fiction',
      description: 'A scientist creates a living being from dead tissue, only to be horrified by the consequences of his actions.',
      rating: 4.6,
      year: 1818,
    },
    {
      id: '16',
      title: 'Slaughterhouse-Five',
      author: 'Kurt Vonnegut',
      cover: 'https://covers.openlibrary.org/b/id/7346695-L.jpg',
      category: 'Science Fiction',
      description: 'A soldier experiences time travel while reflecting on the absurdity of war, blending science fiction with deep philosophical themes.',
      rating: 4.3,
      year: 1969,
    },
  ];
  
  const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(-10px); }
  100% { opacity: 1; transform: translateY(0); }
`;
function Elibrary() {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedCategory, setExpandedCategory] = useState(false);
  const [expandedRating, setExpandedRating] = useState(false);
  const [expandedYear, setExpandedYear] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedRating, setSelectedRating] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [likedBooks, setLikedBooks] = useState({});

  const categories = Array.from(new Set(books.map((book) => book.category)));
  const years = Array.from(new Set(books.map((book) => book.year)));

  const handleLikeClick = (bookId) => {
    setLikedBooks((prevState) => ({
      ...prevState,
      [bookId]: !prevState[bookId],
    }));
  };

  const filteredBooks = books.filter(
    (book) =>
      (book.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        book.author.toLowerCase().includes(searchQuery.toLowerCase()) ||
        book.category.toLowerCase().includes(searchQuery.toLowerCase())) &&
      (selectedCategories.length === 0 || selectedCategories.includes(book.category)) &&
      (selectedRating.length === 0 || selectedRating.includes(book.rating.toString())) &&
      (selectedYear === '' || book.year.toString() === selectedYear)
  );

  const handleCategoryFilterChange = (category) => {
    setSelectedCategories((prevState) =>
      prevState.includes(category) ? prevState.filter((c) => c !== category) : [...prevState, category]
    );
  };

  const handleRatingFilterChange = (rating) => {
    setSelectedRating((prevState) =>
      prevState.includes(rating) ? prevState.filter((r) => r !== rating) : [...prevState, rating]
    );
  };

  const handleYearFilterChange = (year) => {
    setSelectedYear(year === selectedYear ? '' : year);
  };
  
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f4f6f8' }}>
      <Headers/>
    {/* Header */}
    <AppBar
      position="sticky"
      sx={{
        background: 'linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)',
        boxShadow: 4,
        marginTop: '15px'
      }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between',  }}>
        {/* eLibrary Title with style enhancements and fade-in animation */}
        <Typography
          variant="h4"
          sx={{
            flexGrow: 1,
            fontWeight: 'bold',
            letterSpacing: 2,
            color: 'white',
            animation: `${fadeIn} 1s ease-out`,
          }}
        >
          eLibrary
        </Typography>
  
        {/* Home Icon with animation and hover effects */}
        <Box sx={{ position: 'relative' }}>
          <IconButton
            color="inherit"
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                transform: 'scale(1.1)',
                transition: 'transform 0.3s ease, background-color 0.3s ease',
              },
            }}
          >
            <LibraryBooks sx={{ fontSize: 28 }} />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  
    {/* Main Content */}
    <Box sx={{ display: 'flex', paddingTop: 4 }}>
      {/* Filters Sidebar */}
      <Box
        sx={{
          width: '300px', // Further increased the width of the filter sidebar
          padding: 2,
          borderRight: 1,
          borderColor: 'divider',
          backgroundColor: 'white',
          boxShadow: 2,
          borderRadius: 2, // Rounded corners for sidebar
        }}
      >
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
          Filters
        </Typography>
  
        {/* Search */}
        <Box sx={{ marginBottom: 2, display: 'flex', alignItems: 'center', backgroundColor: '#f0f2f5', padding: 1, borderRadius: '5px' }}>
          <Search sx={{ marginRight: 1, color: '#777' }} />
          <InputBase
            placeholder="Search books"
            sx={{ width: '100%', fontSize: '14px' }}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Box>
  
        <Divider sx={{ margin: '10px 0' }} />
  
        {/* Category Filter */}
        <Accordion expanded={expandedCategory} onChange={() => setExpandedCategory(!expandedCategory)}>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Category
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {categories.map((category) => (
              <FormControlLabel
                key={category}
                control={<Checkbox checked={selectedCategories.includes(category)} onChange={() => handleCategoryFilterChange(category)} />}
                label={category}
              />
            ))}
          </AccordionDetails>
        </Accordion>
  
        {/* Rating Filter */}
        <Accordion expanded={expandedRating} onChange={() => setExpandedRating(!expandedRating)}>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel2a-content" id="panel2a-header">
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Rating
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {[4.5, 4.7, 4.8].map((rating) => (
              <FormControlLabel
                key={rating}
                control={<Checkbox checked={selectedRating.includes(rating.toString())} onChange={() => handleRatingFilterChange(rating.toString())} />}
                label={`${rating} & above`}
              />
            ))}
          </AccordionDetails>
        </Accordion>
  
        {/* Year Filter */}
        <Accordion expanded={expandedYear} onChange={() => setExpandedYear(!expandedYear)}>
          <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel3a-content" id="panel3a-header">
            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
              Year
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {years.map((year) => (
              <FormControlLabel
                key={year}
                control={<Checkbox checked={selectedYear === year.toString()} onChange={() => handleYearFilterChange(year.toString())} />}
                label={year}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      </Box>
  
      {/* Books Grid */}
      <Box sx={{ flexGrow: 1, padding: 2, maxWidth: 'calc(100% - 300px)' }}> {/* Adjusted width for the books grid */}
        <Grid container spacing={3}>
          {filteredBooks.map((book) => (
            <Grid item xs={12} sm={6} md={4} key={book.id}>
              <Card sx={{ height: '100%', position: 'relative', boxShadow: 3, borderRadius: 2 }}>
                {/* Like Button */}
                <IconButton
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    boxShadow: 1,
                    '&:hover': { backgroundColor: '#f5f5f5' },
                  }}
                  onClick={() => handleLikeClick(book.id)}
                >
                  <Favorite sx={{ color: likedBooks[book.id] ? 'red' : 'gray' }} />
                </IconButton>
  
                {/* Book Image */}
                <CardMedia
                  component="img"
                  height="250"
                  image={book.cover}
                  alt={book.title}
                  sx={{ objectFit: 'cover', borderRadius: '8px' }}
                />
  
                {/* Card Content */}
                <CardContent sx={{ padding: 2 }}>
                  <Typography variant="h6" component="div" noWrap sx={{ fontWeight: 'bold' }}>
                    {book.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {book.author}
                  </Typography>
  
                  <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 1 }}>
                    <Star sx={{ color: 'warning.main' }} />
                    <Typography variant="body2" color="textSecondary" sx={{ marginLeft: 1 }}>
                      {book.rating}
                    </Typography>
                  </Box>
  
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 3 }}>
                    {/* Category Badge (Prevent wrapping) */}
                    <Badge
                      badgeContent={book.category}
                      color="primary"
                      sx={{
                        paddingLeft: '50px',
                        whiteSpace: 'nowrap', // Ensure category text doesn't wrap
                        overflow: 'none',   // Hide overflow
                        textOverflow: 'ellipsis', // Optional: Adds ellipsis if the text overflows
                      }}
                    />
  
                    {/* Year Display */}
                    <Typography variant="body2" color="textSecondary" sx={{ marginLeft: 'auto' }}>
                      {book.year}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
          {filteredBooks.length === 0 && (
            <Box sx={{ width: '100%', textAlign: 'center', padding: 4 }}>
              <Typography variant="body1" color="textSecondary">
                No books found matching your search.
              </Typography>
            </Box>
          )}
        </Grid>
      </Box>
    </Box>
  </div>
  
  );
}

export default Elibrary;
